/**
 * Pastilles de coloris — survol : affiche le nom du coloris et remplace
 * l'image de la carte produit par celle du coloris survolé.
 *
 * Anciennement inline dans snippets/color-swatches.liquid, hors du {% if %} :
 * le script était donc dupliqué une fois par carte produit, et chaque pastille
 * finissait avec autant de listeners que de produits affichés sur la page.
 *
 * Ici : un seul fichier, deux listeners délégués sur le document, quel que
 * soit le nombre de produits. Fonctionne aussi sur le contenu injecté après
 * coup (filtres de collection, pagination « voir plus »).
 */
(function () {
  'use strict';

  var SWATCH = '.color-swatch';
  var CONTAINER = '.color-swatches';

  function cardImage(swatch) {
    var card = swatch.closest('.card-wrapper');
    return card ? card.querySelector('.card__media img') : null;
  }

  /** Mémorise src/srcset d'origine au premier survol, pour pouvoir restaurer. */
  function remember(img) {
    if (img.dataset.swatchOriginalSrc === undefined) {
      img.dataset.swatchOriginalSrc = img.getAttribute('src') || '';
      img.dataset.swatchOriginalSrcset = img.getAttribute('srcset') || '';
    }
  }

  function restore(img) {
    if (img.dataset.swatchOriginalSrc === undefined) return;
    img.setAttribute('src', img.dataset.swatchOriginalSrc);
    // Le srcset DOIT être restauré : l'ancienne version le vidait sans jamais
    // le remettre, ce qui détruisait le responsive de l'image après un survol.
    if (img.dataset.swatchOriginalSrcset) {
      img.setAttribute('srcset', img.dataset.swatchOriginalSrcset);
    } else {
      img.removeAttribute('srcset');
    }
  }

  document.addEventListener(
    'mouseover',
    function (event) {
      var swatch = event.target.closest ? event.target.closest(SWATCH) : null;
      if (!swatch) return;

      var container = swatch.closest(CONTAINER);
      if (!container) return;

      var nameEl = container.querySelector('.color-swatches__name');
      if (nameEl) nameEl.textContent = swatch.getAttribute('data-swatch-color-name') || '';

      var newImage = swatch.getAttribute('data-swatch-image');
      var img = cardImage(swatch);
      if (img && newImage) {
        remember(img);
        img.setAttribute('src', newImage);
        // On retire le srcset le temps du survol, sinon le navigateur
        // continuerait de choisir une source de l'ancien coloris.
        img.removeAttribute('srcset');
      }
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      var container = event.target.closest ? event.target.closest(CONTAINER) : null;
      if (!container) return;

      // Ignore les déplacements d'une pastille à l'autre dans le même conteneur.
      var to = event.relatedTarget;
      if (to && container.contains(to)) return;

      var nameEl = container.querySelector('.color-swatches__name');
      if (nameEl) nameEl.textContent = '';

      var card = container.closest('.card-wrapper');
      var img = card ? card.querySelector('.card__media img') : null;
      if (img) restore(img);
    },
    true
  );
})();
